import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  handleFavoriteClick, handleNotifyClick, renderNotify, renderFavorite
} from './top_icons_utils';
import { useFavoriteAdvisor } from './hooks/useFavoriteAdvisor';
import classes from './classes.module.scss';
import { isWebView } from '../../../../common/config/utils';
import { SvgIcon } from '../../../../common/sprites';
import { useNotification } from '../../firebase_messaging_provider';

function TopIcons({
  id, favorite, t,
  displayRegister, authPendingAction, displayNotifyMe,
  loader, theme, availabilityNotification, advisorStatus
}) {
  const location = useLocation();
  const { requestPermission } = useNotification();
  const { favorite: currentFavorite, isLoading: favoriteLoading, toggleFavorite } = useFavoriteAdvisor(id, favorite);

  const onFavClick = (e) => {
    handleFavoriteClick(e, toggleFavorite, currentFavorite, id, displayRegister, authPendingAction, location, favoriteLoading);
    if (!favorite) requestPermission();
  };

  const onNotifyClick = (e) => {
    handleNotifyClick(e, displayNotifyMe, id, authPendingAction, displayRegister, location);
    if (!availabilityNotification?.switchedOn) requestPermission();
  };

  const onShare = () => {
    navigator.share({
      text: t('advisor_profile.share_message'),
      url: window.location.href
    });
  };

  const shareTopIcon = () => (
    <button
      type="button"
      onClick={ onShare }
      className={ classes.iconButton }
    >
      <SvgIcon id="black_share" className={ classes.topIconImgBlack } />
      <SvgIcon id="white_share" className={ classes.topIconImgWhite } />
    </button>
  );

  if (loader) return null;

  return (
    <div className={ classes[theme] }>
      <div className={ classes.iconsSectionContainer } suppressHydrationWarning>
        {!isWebView() && renderNotify({
          onNotifyClick, availabilityNotification, advisorStatus, t
        }) }
        { renderFavorite(onFavClick, currentFavorite) }
        { navigator.share ? shareTopIcon() : null }
      </div>
    </div>
  );
}

export default TopIcons;
